import { render, staticRenderFns } from "./CreateBusinessOpportunity.vue?vue&type=template&id=25e9d6b7&scoped=true"
import script from "./CreateBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./CreateBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./CreateBusinessOpportunity.vue?vue&type=style&index=0&id=25e9d6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9d6b7",
  null
  
)

export default component.exports